export default __webpack_public_path__ + "static/media/team19.5a1a5fb2.JPG";